export const DEFAULT_SPEED_OPTIONS = [0.8, 1, 1.2, 1.5, 2];
export const MIN_VOLUME = 0;
export const MAX_VOLUME = 1;
export const VOLUME_STEP = 0.05;
export const MINI_PROGRESS_WIDTH_DESKTOP = '240px';
export const MINI_PROGRESS_WIDTH_LARGE_DESKTOP = '380px';
export const MINI_SIDE_CONTAINER_WIDTH_DESKTOP = '300px';
export const MINI_SIDE_CONTAINER_WIDTH_LARGE_DESKTOP = '350px';
export const FULL_PLAYER_MAX_WIDTH_TABLET = '472px';
export const FULL_PLAYER_TEXT_LABEL_GUTTER = '4px';
export const FULL_PLAYER_ARTWORK_SIZE_DESKTOP = 340;
export const FULL_PLAYER_ARTWORK_LABEL_GAP_DESKTOP = 20;
export const AUDIO_FALLBACK_IMAGE_1X1_SRC =
  '/audio-player/audio-fallback-1x1.svg';
export const AUDIO_FALLBACK_IMAGE_16X9_SRC =
  '/audio-player/audio-fallback-16x9.svg';
export const ASSET_INTERACTION_CLASS =
  'transform-gpu transition-transform duration-[var(--playback-button-spring-duration)] ease-[var(--playback-button-spring-easing)] scale-[var(--playback-button-scale-default)] group-hover:scale-[var(--playback-button-scale-hover)] group-active:scale-[var(--playback-button-scale-pressed)]';
export const PLAYBACK_CONTROL_SIZE_MOBILE = {
  skipTrack: 44,
  seek: 52,
  playPause: 60,
} as const;
export const PLAYBACK_CONTROL_SIZE_DESKTOP = {
  skipTrack: 36,
  seek: 36,
  playPause: 40,
} as const;
export const PLAYBACK_CONTROL_BUTTON_CLASS =
  'group flex shrink-0 items-center justify-center rounded-full';
